import { render, staticRenderFns } from "./PagedCartItemsLocal.vue?vue&type=template&id=50db0ee5&"
import script from "./PagedCartItemsLocal.vue?vue&type=script&lang=js&"
export * from "./PagedCartItemsLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports